<template>
  <v-footer app elevation="6" v-if="!isComplete">
    <div class="mx-auto" v-if="tab != 1 || questionsCompleteForThisUser">
      <v-btn
        dark
        class="mx-4"
        x-large
        color="performance"
        v-if="tab != 0"
        @click="tab--"
      >
        <v-icon class="mr-2">keyboard_arrow_left</v-icon>
        Previous: {{ text(false) }}
      </v-btn>
      <v-btn
        dark
        class="mx-4"
        x-large
        color="performance"
        v-if="tab != 2"
        @click="tab++"
      >
        Next Up: {{ text(true) }}
        <v-icon class="ml-2">keyboard_arrow_right</v-icon>
      </v-btn>
    </div>
    <v-container v-else-if="canSubmit">
      <v-row class="text-center">
        <v-col cols="12">
          <v-icon color="accent">$vuetify.icons.core_counts</v-icon>
        </v-col>
        <v-col cols="12">
          By clicking the submit button below, you authorize CoreCounts to share
          your answers with
          {{ (is_user ? annualreview.manager : annualreview.user).fullName }} &
          your companies HR representative.
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="text-center">
        <v-col cols="12">
          <v-btn
            color="performance"
            x-large
            :disabled="!canSubmit"
            @click="$emit('save')"
          >
            Submit & Proceed
            <v-icon class="ml-2">keyboard_arrow_right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AnnualReviewFooter",
  components: {},
  props: {},
  data: () => ({}),
  computed: {
    text() {
      return next => {
        var otherTab = this.tab;
        if (next) {
          otherTab++;
        } else {
          otherTab--;
        }
        switch (otherTab) {
          case 0:
            return "CoreBoard";
          case 1:
            return "Q&A Review";
          case 2:
            return "Sign Off";
        }
      };
    },
    tab: {
      get() {
        return this.annualreview_tab;
      },
      set(val) {
        this.$store.dispatch("annualreview/setTab", val);
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isComplete() {
      return this.annualreview.completeDate != null;
    },
    questionsCompleteForThisUser() {
      return (
        (this.is_user
          ? this.annualreview.userQuestionsCompleteDate
          : this.annualreview.managerQuestionsCompleteDate) != null
      );
    },
    canSubmit() {
      let questionsFinished =
        this.completed_answers.length == this.question_count;

      if (this.is_user) {
        return questionsFinished;
      } else {
        return questionsFinished && this.annualreview.userRating != null;
      }
    },
    ...mapGetters({
      annualreview: "annualreview/annualreview",
      annualreview_tab: "annualreview/tab",
      question_count: "annualreview/question_count",
      profile: "profile/profile",
      is_user: "annualreview/is_user",
      completed_answers: "annualreview/completed_answers"
    })
  },
  methods: {}
};
</script>
